import { MouseEvent } from "react";
import { useTranslation } from "@localization/useTranslation";
import { mitigationStatusColor, mitigationStatusTranslationKey, RiskMitigationPlanStatus } from "./riskMitigationStatus";
import TreatmentChipBase from "./TreatmentChipBase";

interface RiskMitigationStatusChipProps {
    mitigationPlanStatus: RiskMitigationPlanStatus;
    showCaret?: boolean;
    onClick?: (event: MouseEvent<HTMLElement>) => void;
}

// The mitigation plan's sub-status pill (Proposed/Planned/…). Shown in the mitigation overview and in
// the assessments-overview Mitigation column; the treatment type itself is rendered by RiskTreatmentChip.
function RiskMitigationStatusChip({ mitigationPlanStatus, showCaret, onClick }: RiskMitigationStatusChipProps) {
    const { translateString } = useTranslation();

    return (
        <TreatmentChipBase
            label={translateString(mitigationStatusTranslationKey[mitigationPlanStatus])}
            color={mitigationStatusColor[mitigationPlanStatus]}
            showCaret={showCaret}
            onClick={onClick}
        />
    );
}

export default RiskMitigationStatusChip;
